import directives from './module';
import {Utils} from 'underscore-extensions';
import {PlayerSvc} from '../services/PlayerSvc';

directives.directive('modalDialog', function ($timeout: ng.ITimeoutService,
                                              $rootScope: ng.IRootScopeService,
                                              $compile: ng.ICompileService,
                                              $animate: any,
                                              PlayerSvc: PlayerSvc) {
    const animationClass = 'animation';
    return {
        restrict: 'EA',
        scope: {
            show: '=',
            dialogTitle: '@',
            onClose: '&?',
            onClickOutside: '&?',
            modalUrl: '@',
            additionalClasses: '@',
            onChange: '&?',
            disableClickOutside: '=?',
            directive: '@'
        },
        transclude: true,
        templateUrl: require('modal-template.html'),
        link: function(this: any, scope: any, element: ng.IAugmentedJQuery, attrs: any) {
            const removeHtmlClass = () => document.documentElement.classList.remove('modal-shown');
            const stateChangeSuccessOff = $rootScope.$on('$stateChangeStart', () => {
                removeHtmlClass();
                stateChangeSuccessOff();
            });

            let directiveScope: ng.IScope = scope.$new(true);
            scope.closeButton = typeof attrs.closeButton === 'string';

            const animatedEl = (f: (e: Element) => void) => element[0].firstElementChild && f(element[0].firstElementChild);

            const animationClose = (callback: Function) => {
                const onceExecuted = _.once(callback).bind(this);
                animatedEl((el: HTMLElement) => {
                    el.addEventListener('transitionend', e => scope.$apply(() => onceExecuted()));
                    Utils.rAF(() => el.classList.remove(animationClass));
                });
            };

            const close = () => animationClose(() => {
                if (!attrs.hasOwnProperty('dontAutoClose')) scope.show = false;
                if (_.isFunction(scope.onClickOutside)) scope.onClickOutside();
                _.isFunction(scope.onClose) && scope.onClose();
                removeHtmlClass();
                $rootScope.$emit('modal:close');
            });
            scope.includeLoaded = () => Utils.rAF(() => animatedEl(e => e.classList.add(animationClass)));

            scope.hideModal = (e: MouseEvent) => {
                const target = <HTMLElement>e.target;
                if ((!scope.disableClickOutside && target === element[0].querySelector('.ng-modal-overlay'))
                    || target === element[0].querySelector('.ng-modal-close')) {
                    close();
                    e.stopPropagation();
                    e.preventDefault();
                }
            };

            if (!scope.disableClickOutside) {
                const isInput = () => document.activeElement.getAttribute('contenteditable')
                || document.activeElement.tagName.toLowerCase() === 'input';
                Utils.scopedEvent('keydown', scope, (e: KeyboardEvent) => {
                    if (scope.show && (e.keyCode || e.which) === 27 && !isInput()) {
                        close();
                    }
                }, document, true);
            }

            scope.$watch('show', (newVal: boolean, oldVal: boolean) => {
                directiveScope.$destroy();
                if (angular.isFunction(scope.onChange) && scope.onChange()) {
                    scope.onChange()(newVal, oldVal);
                }
                if (!newVal && oldVal && _.isFunction(scope.onClose)) {
                    //scope.onClose();
                } else if (newVal && !scope.modalUrl) {
                    document.documentElement.classList.add('modal-shown');
                    $rootScope.$emit('modal:show');

                    if (scope.directive) {
                        directiveScope = scope.$new(true);
                        const compiled = $compile(document.createElement(scope.directive))(directiveScope);
                        $animate.enter(compiled, null, element.find('transclude-directive')).then(() => {
                            $timeout(() => scope.includeLoaded());
                        });
                    } else {
                        $timeout(() => scope.includeLoaded());
                    }
                }
                !_.isUndefined(newVal) && togglePlayers(newVal);
            });

            function togglePlayers(modalOpened: boolean) {
                PlayerSvc.instances().forEach(p => {
                    if (modalOpened && p.isPlaying()) {
                        p.pause();
                        p._pauseBecauseOfModal = true;
                    } else if (!modalOpened && p._pauseBecauseOfModal) {
                        p._pauseBecauseOfModal = false;
                        p.play();
                    }
                });
            }
        }
    };
});



// WEBPACK FOOTER //
// ./app/assets/javascripts/directives/modalDialogDirective.ts